import { defineLocale } from "../../registry";

const conflict = defineLocale({
  ru: {
    "conflict.loading": "Загружаем актуальную версию…",
    "conflict.loaded":
      "Актуальная версия загружена. Ваши несохранённые значения остались в форме.",
    "conflict.replace": "Заменить версией с сервера",
    "conflict.keep": "Оставить мои значения",
    "conflict.failed": "Не удалось перечитать запись, повторите",
    "conflict.command.title": "Это сохранение отклонено сервером",
    "conflict.command.reloaded":
      "Актуальная версия загружена. Нажмите «Сохранить», чтобы повторить попытку.",
  },
  en: {
    "conflict.loading": "Loading the latest version…",
    "conflict.loaded":
      "The latest version is loaded. Your unsaved values are still in the form.",
    "conflict.replace": "Replace with server version",
    "conflict.keep": "Keep my values",
    "conflict.failed": "Could not reload the record, please retry",
    "conflict.command.title": "This save was rejected by the server",
    "conflict.command.reloaded":
      "The latest version is loaded. Press Save to try again.",
  },
});

export default conflict;
